import { useSelector } from "react-redux";
import { createMuiTheme } from "@material-ui/core/styles";

export const useTheme = () => {
  const siteData = useSelector((state) => state.siteData);
  const siteTheme = siteData?.brandingSettings?.form?.theme;
  //console.log("THEME", siteTheme)
  return createMuiTheme(siteTheme);
};
